
"use client";
import CommentFloor from "@/components/customerReviews/commentFloor";
import VideoPay from "@/components/videoDom/icons/videoPay_top.svg";
import React from "react";
import AllCommentList from "./allCommentList";
import "./index.scss";
import ScoreRating from "./scoreRating";

import { getInitCommentListPage } from "@/apis/dp/service";
import { IntlDialog } from "@/components/intlMui";
import { dataExpTagConfig } from "@/components/product/const";
import ReviewDetail from "@/components/reviewDetail";
import { useTranslation } from "@/i18n/client";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25217";
import { imageUtil } from "@/utils/imageUtil";
import { useParams } from "next/navigation";
import { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";

export default function CustomerReviews({ data }: any) {
  
  const { commentCount, star, tagList = [], commentDetails = [], imgVideoCommentList = [], starShow } = data || {};
  const [allCommentInfo, setAllCommentInfo] = useState<any>(); // 评论列表数据
  const [isLoading, setIsLoading] = useState<boolean>(false); // 评论列表弹窗
  const [isError, setIsError] = useState<boolean>(false); // 评论列表弹窗
  const [reviewList, setReviewList] = useState<any>(); // 评论列表数据
  const [reviewType, setReviewType] = useState<string>(""); // 评论类型
  const [open, setOpen] = useState<boolean>(false); // 评论列表弹窗
  const { sku: skuId } = useParams<{ sku: string }>(); // 商品id
  const { t } = useTranslation(); // 国际化
  const [commentIdList,setCommentIdList] =useState('')
  const [showDetail,setShowDetail]=useState(false)
  const [reviewDetail,setReviewDetail]=useState<any>({})
  // 商详评价展示两条文本评价，下发的数据里面文本若为空则不展示
  React.useEffect(() => {
    if (commentDetails?.length > 0) {
      setReviewList(commentDetails?.filter((item: any) => item.content));
      const ids=commentDetails.filter((item:{commentId:string}) => item.commentId)
      .map((item:{commentId:string}) => item.commentId)
      .join(',');
      setCommentIdList(ids)
    }
  }, [commentDetails]);

  // 打开评论列表弹窗
  const openReviewListDialog = async (v?: string, index?: number,params?:string) => {
    if (v) {
      setReviewType(v);
      sendClickTrack.Productdetail_ReviewsFloor_Picture_Click({
        mainskuid: skuId,
        index: index || 0,
      });
    } else {
      setReviewType("");
      sendClickTrack.Productdetail_ReviewsFloor_ViewAll_Click({
        mainskuid: skuId,
      });
    }
    setOpen(true);
    // setIsLoading(true);
    try {
      const res = await getInitCommentListPage({skuId,topIdList:commentIdList});
      if (res?.success) {
        setAllCommentInfo(res?.data);
        setIsError(false);
      }
      // setIsLoading(false);
    } catch (error) {
      setIsError(true);
      // setIsLoading(false);
    }
  };
  const openReviewDetail=(item:any)=>{
    setShowDetail(true);
    let arr=imgVideoCommentList.filter((t:any)=>{
      console.log(t.commentId,item.commentId)
      return t.commentId === item.commentId;
    });
    setReviewDetail(arr[0] || {});
  };
  // 关闭评论列表弹窗
  const closeReviewListDialog = () => {
    setOpen(false);
  };
  // 处理图片视频评论列表
  const l = imgVideoCommentList?.map((item: any) => {
    if (item.videoList?.length > 0) {
      return { type: 0, src: item.videoList[0].videoUrl ,commentId:item.commentId,parentReplyId:item.parentReplyId};
    } else if (item.imageList?.length > 0) {
      return { type: 1, src: item.imageList?.[0]?.imageUrl,commentId:item.commentId ,parentReplyId:item.parentReplyId};
    } else {
      return null;
    }
  });
  // 处理图片视频评论列表
  const transformedImgVideoCommentList = l?.filter((item: any) => item)?.slice(0, 5);

  // 筛选
  const reviewFilterFn = async (value: number) => {
    setReviewType("");
    setIsError(false);
    setIsLoading(true);
    try {
      const res = await getInitCommentListPage({ skuId, type: value ,topIdList:commentIdList});
      if (res?.success) {
        setAllCommentInfo(res?.data);
        setIsError(false);
      }
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
    }
  };
  const sortClickedString = (str:string, clickedItem:string)=> {
    const items = str.split(',').map(item => item.trim());
    const clicked = [clickedItem];
    return [
      ...items.filter(item => clicked.includes(item)),
      ...items.filter(item => !clicked.includes(item))
    ].join(', ');
  }
  //点击商详里的评价跳转评价列表
  const handleReviewItem = async (commentId:number)=>{
    const ids=sortClickedString(commentIdList,String(commentId))
    setOpen(true);
    setIsLoading(true);
    try {
      const res = await getInitCommentListPage({ 
        skuId ,
        topIdList:ids
      });
      if (res?.success) {
        setAllCommentInfo(res?.data);
        setIsError(false);
      }
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
    }
  }
  return (
    <>
      <div
        className="customer-reviews-box"
        exptag={"exp|" + EXPOSURE_RECORD.Productdetail_ReviewsFloor_Expo}
        data-exptag-config={dataExpTagConfig}
        data-exptag-json-param={JSON.stringify({ mainskuid: skuId })}
      >
        {/*  标题 */}
        <div className="title-box">
          <div className="title-h-box">
            <h2 className="title-h1">{t("review.reviewTitle")} </h2>
            {/* 删除All from verified purchases */}
            {/* <div className="basic-font title-h2" style={{ color: "#888B94" }}>
              <i className="verified-icon" />
              {t("review.reviewPlaceholder")}
            </div> */}
          </div>
          
        </div>
        {/*  评分*/}
        <ErrorBoundary fallback={null}>
          <ScoreRating value={star} starShow={starShow} commentCount={commentCount} />
        </ErrorBoundary>
        {/* 关键词 */}
       {reviewList?.length!==0&&<div className="key-box">
          {tagList?.map(({ tag }: { tag: string }, index: number) => (
            <span key={index} className="key">
              {tag}
            </span>
          ))}
        </div>
        } 
        {/* 商详评论 */}
        <div className="reviews-list-box">
          <ErrorBoundary fallback={null}>
            <CommentFloor lists={reviewList} skuId={skuId} onReviewBlockClick={handleReviewItem} />
          </ErrorBoundary>
          
        </div>
        {/* 图片评论列表 */}
        <ErrorBoundary fallback={null}> 
         {transformedImgVideoCommentList.length !==0 &&(
          <h2 className="title-h1 title-img">{t("review.imageTitle")} </h2>
         )}
          <div className="reviews-img-list-box">
          
            {transformedImgVideoCommentList?.map((item: any, index: number) => {
              if (!item?.src) {
                return null;
              }
              return (
                <div
                  className="reviews-img-card"
                  key={index}
                  onClick={() => openReviewDetail(item)}
                  exptag={"exp|" + EXPOSURE_RECORD.Productdetail_ReviewsFloor_Picture_Expo}
                  data-exptag-config={dataExpTagConfig}
                  data-exptag-json-param={JSON.stringify({ mainskuid: skuId, index: index })}
                >
                  {item.src && (
                    <div key={index}>
                      {item.type === 0 && (
                        <div style={{ width: "140px", height: "140px", position: "relative" }}>
                          <video style={{ width: "140px", height: "140px", objectFit: "cover" }} src={item.src}></video>
                          <VideoPay style={{ position: "absolute", top: "10px", left: "10px" }} />
                        </div>
                      )}
                      {item.type === 1 && (
                        <img
                          src={imageUtil.concatImgUrlWithoutForceHttps(item.src, 240, 0, 100, process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(","))}
                          alt=""
                        />
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </ErrorBoundary>
        {reviewList?.length!==0&&<div className="basic-font flex font-hover view-all" onClick={() => openReviewListDialog("")}>
            {t("review.viewAll")} 
            {/* <i className="view-all-icon"></i> */}
          </div>
        }
      </div>
      {/* 所有评论列表弹窗 */}
      <IntlDialog
        onClose={closeReviewListDialog}
        aria-labelledby="customized-dialog-title"
        open={open}
        title={t("review.reviewTitle")}
        content={
          <AllCommentList skuId={skuId} isError={isError} isLoading={isLoading} data={allCommentInfo} reviewType={reviewType} reviewFilterFn={reviewFilterFn} />
        }
        width={800}
        showButtonAction={false}
      />
      {/* 查看详情弹窗 */}
      {showDetail&&<ReviewDetail detailData={reviewDetail} skuId={skuId}  showDetail={showDetail} setShowDetail={setShowDetail} />}
    </>
  );
}
